export default __webpack_public_path__ + "static/media/contact.c759ebe8.svg";